<template>
    <div class="i-wrapper">
        <slot/>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                folded: localStorage.sidebarFolded === '1'
            }
        }
    }
</script>

<style scoped>
    .i-wrapper{
        float:left;
        width:calc(100% - 202px);
        
    }
</style>